module.exports = __webpack_public_path__ + "img/about-new-img.499fef8d.png";